import swal from 'sweetalert2'
import { apolloProvider } from '@/vue-apollo'
import mixins from '@/mixins.js'

export const state = {
  screenMode: {
    name: '',
    size: 0
  },
  drawer: {
    type: null,
    itemID: null,
    size: 'sm',
    show: false,
    changed: false,
    loading: false
  },
  activeMenuPanel: null,
  validation: {
    rules: {
      required: v => !!v || 'This field is required.',
      email: v =>
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Email address is not valid.',
      hex: v =>
        /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i.test(v) || 'Hex color is not valid.'
    }
  }
}

export const getters = {}

export const actions = {
  openEditor({ commit }, payload) {
    if (state.drawer.changed) {
      swal({
        title: 'Are you sure?',
        text: 'You have unsaved changes that will be lost.',
        type: 'warning',
        confirmButtonText: 'Discard changes',
        cancelButtonText: 'Go back to editing',
        showCancelButton: true,
        allowOutsideClick: false
      }).then(({ value }) => {
        if (value) {
          commit('OPEN_EDITOR', payload)

          apolloProvider.defaultClient.resetStore()
        }
      })
    } else {
      commit('OPEN_EDITOR', payload)
    }
  },
  closeEditor({ state, commit }) {
    if (state.drawer.changed) {
      swal({
        title: 'Are you sure?',
        text: 'You have unsaved changes that will be lost.',
        type: 'warning',
        confirmButtonText: 'Discard changes',
        cancelButtonText: 'Go back to editing',
        showCancelButton: true,
        allowOutsideClick: false
      }).then(({ value }) => {
        if (value) {
          commit('CLOSE_EDITOR')

          apolloProvider.defaultClient.resetStore()
        }
      })
    } else {
      commit('CLOSE_EDITOR')
    }
  },
  saveChanges({ commit, dispatch }, payload) {
    commit('SET_DRAWER_LOADING', true)

    apolloProvider.defaultClient
      .mutate({ mutation: payload.mutation, variables: payload.variables })
      .then(() => {
        if (payload.refetch) {
          apolloProvider.defaultClient.resetStore()
        }

        let message =
          payload.messages.success || 'Changes successfully applied.'

        mixins.methods.handleGraphQLSuccess(message)

        commit('SET_DRAWER_LOADING', false)
        commit('SET_DRAWER_CHANGED', false)

        if (payload.close) {
          dispatch('closeEditor')
        }
      })
      .catch(error => {
        mixins.methods.handleGraphQLErrors(error)

        commit('SET_DRAWER_LOADING', false)
      })
  },
  confirmAndSaveChanges({ dispatch }, payload) {
    swal({
      title: 'Are you sure?',
      text: payload.messages.confirm || 'You will not be able to revert this.',
      type: 'warning',
      showCancelButton: true,
      allowOutsideClick: false
    }).then(({ value }) => {
      if (value) {
        dispatch('saveChanges', payload)
      }
    })
  }
}

export const mutations = {
  SET_SCREEN_MODE(state, screenMode) {
    state.screenMode.name = screenMode.name
    state.screenMode.size = screenMode.size
  },
  OPEN_EDITOR(state, payload) {
    state.drawer.type = payload.type
    state.drawer.itemID = payload.itemID || null
    state.drawer.size = payload.size || 'sm'
    state.drawer.changed = false
    state.drawer.loading = false
    state.drawer.show = true
  },
  CLOSE_EDITOR(state) {
    state.drawer.type = null
    state.drawer.itemID = null
    state.drawer.size = 'sm'
    state.drawer.changed = false
    state.drawer.loading = false
    state.drawer.show = false
  },
  SET_DRAWER_CHANGED(state, changed) {
    state.drawer.changed = changed
  },
  SET_DRAWER_LOADING(state, loading) {
    state.drawer.loading = loading
  }
}
